import { getEnvironment } from '@hopin-team/dashboard-constants';
import React from 'react';
import { Helmet } from 'react-helmet';

const API_KEY = '4e494400-be49-40d6-602e-7b0389732ebd';

type PendoProps = {
  userExternalId: string;
  userEmail: string;
  organizationExternalId: string;
  paymentPlan: string;
};

/**
 * Pendo is a marketing solution that allows displaying release notes
 * on the "What's new" section. This tool is used throughout RingCentral
 * and now in RingCentral Events product.
 *
 * Developers docs: https://support.pendo.io/hc/en-us/articles/360046272771
 */
export function Pendo({
  userExternalId,
  userEmail,
  organizationExternalId,
  paymentPlan,
}: PendoProps) {
  if (
    getEnvironment() !== 'production' ||
    userEmail.startsWith('automated-tests')
  ) {
    return null;
  }

  /**
   * In the Event's Dashboard, Pendo's payload emits payment plan names in kebab_case, example:
   * - Events_Ecommerce_500
   *
   * Meanwhile Organisation's Dashboard receives payment plan names without underscore(s),
   * therefore we change it to kebab_case before sending to keep the consistency on the Pendo Dashboard's end.
   */
  const formattedPaymentPlan = paymentPlan.replaceAll(' ', '_');

  return (
    <Helmet>
      <script type="text/javascript">
        {`
            (function(apiKey){
                (function(p,e,n,d,o){var v,w,x,y,z;o=p[d]=p[d]||{};o._q=o._q||[];
                v=['initialize','identify','updateOptions','pageLoad','track'];for(w=0,x=v.length;w<x;++w)(function(m){
                    o[m]=o[m]||function(){o._q[m===v[0]?'unshift':'push']([m].concat([].slice.call(arguments,0)));};})(v[w]);
                    y=e.createElement(n);y.async=!0;y.src='https://cdn.pendo.io/agent/static/'+apiKey+'/pendo.js';
                    z=e.getElementsByTagName(n)[0];z.parentNode.insertBefore(y,z);})(window,document,'script','pendo');
            
                    // This function creates visitors and accounts in Pendo
                    pendo.initialize({
                        visitor: {
                            id: '${userExternalId}',
                        },
                        account: {
                            id: '${organizationExternalId}',
                            paymentPlan: '${formattedPaymentPlan}',
                        }
                    });
            })('${API_KEY}');
        `}
      </script>
    </Helmet>
  );
}
